import { Component, OnInit, OnDestroy } from '@angular/core';
import { ISubscription } from 'rxjs/Subscription';
import { SearchEditionParams, EDITION_SECTIONS, PATTERN_DISTANCES,
    LISTAPP_FIELDS, ListAppWitness, ListAppWitnessHand, ListAppCause } from '../../../models/search-edition-params';
import { SearchEditionService } from '../../../services/search-edition.service';
import { CriticalEditionService } from '../../../services/critical-edition.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
    selector: 'app-search-edition-form',
    templateUrl: './search-edition-form.component.html',
    styleUrls: ['./search-edition-form.component.css']
})
export class SearchEditionFormComponent implements OnInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    ceSections = EDITION_SECTIONS;
    patternDistances = PATTERN_DISTANCES;
    listAppFields = LISTAPP_FIELDS;
    listAppWitnesses: Array<ListAppWitness> = [];
    listAppWitnessHands: Array<ListAppWitnessHand> = [];
    listAppCauses: Array<ListAppCause> = [];
    searchParams: SearchEditionParams;
    searchAll = false;

    constructor(
        private criticalEditionService: CriticalEditionService,
        private searchEditionService: SearchEditionService
    ) {
    }

    ngOnInit() {
        this.subscriptions.push(
            this.criticalEditionService.getDocInfo('').subscribe(
                ceInfo => {
                    if (ceInfo && ceInfo.witnesses && ceInfo.witnesses.length > 0) {
                        for (const witnessInfo of ceInfo.witnesses) {
                            this.listAppWitnesses.push({key: witnessInfo.witness, label: witnessInfo.witness});
                            for (const hand of witnessInfo.hands) {
                                this.listAppWitnessHands.push({key: hand, label: hand});
                            }
                        }
                    }
                }
            ),
            this.criticalEditionService.getAppCauses('').subscribe(
                listAppCauses => {
                    if (listAppCauses && listAppCauses.length > 0) {
                        this.listAppCauses = listAppCauses;
                    }
                }
            ),
            this.searchEditionService.getSearchParams().subscribe(
                params => {
                    if (params) {
                        this.searchParams = params;
                    }
                }
            ),
            this.searchEditionService.isSearchAll().subscribe(
                searchAll => this.searchAll = !!searchAll
            )
        );
    }

    search() {
        this.searchEditionService.resetSearchResultsCache();
        this.searchEditionService.resetSearchEditionSelected();
        this.searchParams.resetPagination();
        if (this.searchParams.section === 'all') {
            this.searchEditionService.updateSearchAllResults(this.searchParams);
        } else {
            this.searchEditionService.updateSearchResults(this.searchParams);
        }
    }

    onChangeSection(event: MatSelectChange) {
        if (event.value === 'all') {
            const pattern = this.searchParams.pattern;
            this.searchParams.init();
            this.searchParams.pattern = pattern;
        } else {
            this.searchParams.resetPagination();
        }
        this.searchEditionService.resetSearchResults();
    }

    onChangeWitness(event: MatSelectChange) {
        if ((<Array<string>> event.value).length > 0) {
            this.searchParams.listApp.hands = [];
        }
    }

    onChangeWitnessHand(event: MatSelectChange) {
        if ((<Array<string>> event.value).length > 0) {
            this.searchParams.listApp.witnesses = [];
        }
    }

    resetSearchAll() {
        this.searchEditionService.resetSearchAllResults();
        this.searchEditionService.resetSearchEditionSelected();
        this.searchParams.resetPagination();
    }

    resetSearchResults() {
        this.searchEditionService.resetSearchResults();
        this.searchEditionService.resetSearchAllResults();
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/search-edition-form/search-edition-form.component.ts